var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Country/luxembourg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Country/luxembourg",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "luxembourg",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,0 C145.929,0 52.094,69.472 15.923,166.957 L496.078,166.957 C459.906,69.472 366.071,0 256,0 Z",
    id: "Path",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,512 C366.071,512 459.906,442.528 496.077,345.043 L15.923,345.043 C52.094,442.528 145.929,512 256,512 Z",
    id: "Path",
    fill: "#338AF5"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLu);
export default __webpack_public_path__ + "static/media/LU.e081ca52037ffdf2ce6a3042580ce5ac.svg";
export { ForwardRef as ReactComponent };